import { render, staticRenderFns } from "./PricingEdit.vue?vue&type=template&id=764ba074"
import script from "./PricingEdit.vue?vue&type=script&lang=js"
export * from "./PricingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports